<template>
    <td
    class="calendar-day"
    :class="{
    'calendar-day-not-current-month': !day.isCurrentMonth,
    'calendar-day-today': isToday,
    }"
    >
        <span
            v-if="day.isCurrentMonth"
            class="day clickable"
            :class="{
            'calendar-selected-date' : (selected !== null && day.date == selected ? true : false),
            }"
            @click="$emit('select', day.date)"
        >
          <span v-text="label" />
        </span>
        <div
            v-if="day.isCurrentMonth"
            class="schedule-list"
        >
            <div
              v-for="(schedule, index) in schedules"
              :key="index"
              class="schedule-item clickable"
              v-text="`${schedule.message}`"
              @click="$emit('select', day.date)"
              :class="{
                'schedule-item-hidden': index >= 3,
                'push-notification-item': schedule.notification_type == 'Push Notification'
              }"
            />
            <span
              class="schedule-count-container"
              v-text="scheduleCounter"
            />
        </div>
    </td>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'CalendarMonthDayItem',
  props: {
    day: {
      type: Object,
      required: true
    },
    schedules: {
      type: [Object, Array],
      required: false
    },
    isCurrentMonth: {
      type: Boolean,
      default: false
    },
    isToday: {
      type: Boolean,
      default: false
    },
    selected: {
      type: String,
      required: false
    }
  },
  computed: {
    label () {
      return dayjs(this.day.date).format('D')
    },
    scheduleCounter () {
      if (this.schedules !== null) {
        if (this.schedules.length === 4) {
          return '+1'
        } else if (this.schedules.length >= 5) {
          return `+${this.schedules.length - 4}`
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
</style>
